/* eslint-disable global-require */
const axios = require('axios')

module.exports.getNotifications = async (statusId, paymentId, uuid) => {
  const getMessages = await axios.get('https://notification.manyconvert.com/notifications', {
    headers: {
      'Content-Type': 'application/json',
      accept: '*/*',
    },
    params: {
      uuid,
      statusId,
      paymentId,
    },
  }).then(resp => resp.data)

  return getMessages.messages
}

module.exports.deleteNotification = async (statusId, paymentId, uuid) => {
  await axios.delete('https://notification.manyconvert.com/notifications',
    {
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
      },
      data: {
        uuid,
        statusId,
        paymentId,
      },
    })
}

module.exports.createNotification = async (statusId, paymentId, uuid, messages) => {
  await axios.post('https://notification.manyconvert.com/notifications', {
    uuid,
    statusId,
    paymentId,
    messages,
  })
}

module.exports.createAlert = async (uuid, phone) => {
  const resp = await axios.post('https://notification.manyconvert.com/notifications/alert', {
    uuid,
    phone,
  })
  return resp
}

/* ####################################################################
################## ENVIO EM MASSA ###################################
#################################################################### */

/// / Cria Lista de Leads
module.exports.createList = async (ListName, leads, uuid) => {
  const resp = await axios.post(`https://api-notifications.manyconvert.com/leads/${uuid}`, {
    ListName,
    leads,
  })

  return resp
}

/// / Pega Listas de uma loja
module.exports.getLists = async uuid => {
  const resp = await axios.get(`https://api-notifications.manyconvert.com/lists/${uuid}`)

  return resp.data
}

/// / Cria Campanha
module.exports.createCampaign = async (name, message, list, linkImage, textButton, linkButton, schedule, uuid) => {
  const resp = await axios.post(`https://api-notifications.manyconvert.com/campaign/${uuid}`, {
    list,
    message,
    name,
    linkImage,
    textButton,
    linkButton,
    schedule,
  })

  return resp
}
/// // deleta campanha temporariamente
module.exports.deleteCampaign = async (campaign, uuid) => {
  const resp = await axios.put(`https://api-notifications.manyconvert.com/campaign/delete/${uuid}`,
    {
      campaign,
    })

  return resp
}

/// / Traz Campanhas
module.exports.getCampaigns = async uuid => {
  const resp = await axios.get(`https://api-notifications.manyconvert.com/campaign/${uuid}`)

  return resp.data
}

/// / atualiza status da campanha
module.exports.updateStatus = async (status, campaign, instance, uuid) => {
  const resp = await axios.post(`https://api-notifications.manyconvert.com/campaign/status/${uuid}`, {
    status,
    campaign,
    instance,
  })

  return resp
}

/// / Traz instancias
module.exports.getInstances = async uuid => {
  const resp = await axios.get(`https://api-notifications.manyconvert.com/lists/instances/${uuid}`)

  return resp.data.list
}

/// / Traz métricas
module.exports.getMetrics = async (uuid, campaign_id) => {
  const resp = await axios.get(`https://api-notifications.manyconvert.com/campaign/${uuid}/leads/${campaign_id}`)

  return resp.data.leadsCampaign
}
